import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M29.227 35.243c-1.908.605-3.385 1.921-13.965 12.451C6.911 56.005 3.156 60.04 2.496 61.414c-1.358 2.825-1.349 7.198.022 10.053.83 1.729 18.268 19.391 92.147 93.332l91.123 91.199-91.121 91.201C20.854 421.076 3.35 438.805 2.519 440.533c-1.372 2.854-1.382 7.226-.023 10.053.66 1.374 4.416 5.41 12.766 13.721 11.494 11.439 11.903 11.796 14.359 12.506 3.225.933 6.369.637 9.115-.858 1.484-.808 31.824-30.899 108.12-107.232 95.635-95.682 106.136-106.319 106.854-108.243 1.016-2.721 1.016-6.239 0-8.96-.718-1.924-11.219-12.561-106.854-108.243C71.603 67.987 40.209 36.847 38.769 36.063c-2.621-1.426-6.563-1.765-9.542-.82"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow"}) } }